<template>
  <div id="app">
    <Loader />

    <GameFrame ref="view" />

    <CookieBar v-if="!$inApp && $store.state.mode === 'intro'" />

    <RotateDevice />
  </div>
</template>

<script>
import { gsap } from 'gsap';
import { debounce } from 'lodash';
import { CustomEase } from '@/assets/libs/CustomEase';
import { DrawSVGPlugin } from '@/assets/libs/DrawSVGPlugin';

import Loader from '@/components/Loader.vue';
import GameFrame from '@/components/GameFrame.vue';
import RotateDevice from '@/components/RotateDevice/index.vue';
import CookieBar from '@/components/CookieBar.vue';

// import transitions from '@/scripts/transitions';
import { isTouchDevice } from '@/scripts/utils';

gsap.registerPlugin(CustomEase);
gsap.registerPlugin(DrawSVGPlugin);
CustomEase.create('flap', '0.35, 1.30, 0.65, 1');

export default {
  name: 'App',

  components: {
    Loader,
    GameFrame,
    RotateDevice,
    CookieBar,
  },

  mounted() {
    this.resize();
    window.addEventListener('resize', debounce(() => this.resize(), 200));
    // window.addEventListener('blur', () => {
    //   if (this.$store.state.mode === 'playing') this.$eventHub.$emit('pause');
    // });
    this.$eventHub.$on('teaserend', () => this.$store.commit('SET_MODE', 'timeExpired'));

    const sequence = [38, 40, 37, 39, 65, 66];
    const original = [38, 40, 37, 39, 65, 66];
    window.addEventListener('keydown', (e) => {
      if (e.keyCode === sequence[0]) {
        sequence.splice(0, 1);
      } else {
        sequence.length = 0;
        original.forEach((n) => sequence.push(n));
      }
      if (sequence.length === 0) this.$eventHub.$emit('konami-code');
    });

    this.$refs.view.$refs.overlay.load()
      .then(() => this.loadGame().then(() => {
        this.$refs.view.$refs.overlay.leave();
        gsap.from('.stage-frame', { autoAlpha: 0, duration: 1.2, clearProps: 'all' });
        this.$store.commit('SET_LOADED', true);
      }));
  },

  methods: {
    checkTutorialState() {
      if (this.$inApp) {
        this.$store.state.tutorialDone = this.$store.state.userData.score > 0;
      } else {
        const localstorageVal = window.localStorage.getItem('gucci_kenscott:tutorial_done');

        if (localstorageVal) {
          this.$store.state.tutorialDone = parseInt(localstorageVal, 10) > 0;
        } else {
          localStorage.setItem('gucci_kenscott:tutorial_done', 1);
        }
      }
    },
    resize() {
      const vh = window.innerHeight * 0.01;
      const h = window.innerHeight * (((isTouchDevice() && window.innerWidth >= 568) || !isTouchDevice()) ? 0.85 : 1);
      const rw = h / 812;

      document.documentElement.style.setProperty('--vh', `${vh}px`);
      document.documentElement.style.setProperty('--rw', `${rw}`);

      this.$eventHub.$emit('window-resize');
    },
    loadGame() {
      const promises = [this.$game.load()];

      if (this.$inApp) promises.push(this.$store.dispatch('getUserData'));

      return Promise.all(promises).then(() => {
        this.$game.setUpGame();
        this.checkTutorialState();
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/scss/base.scss';
</style>
